export function gapUpLogicStorageKey(date) {
  return `gapup_logic_${date}`
}

export function loadGapUpLogicByCode(date) {
  try {
    const raw = sessionStorage.getItem(gapUpLogicStorageKey(date))
    return raw ? JSON.parse(raw) : {}
  } catch (_e) {
    return {}
  }
}

export function saveGapUpLogicMap(date, map) {
  try {
    sessionStorage.setItem(gapUpLogicStorageKey(date), JSON.stringify(map || {}))
  } catch (_e) {
    /* ignore */
  }
  return map || {}
}

export function saveGapUpLogicEntry(date, code, entry) {
  const map = loadGapUpLogicByCode(date)
  map[code] = entry
  saveGapUpLogicMap(date, map)
  return map
}

export function formatGapUpLogicDisplay(logicMatch) {
  if (!logicMatch) return ''
  if (logicMatch.type === 'switch') return '切换'
  if (logicMatch.type === 'match' && Array.isArray(logicMatch.items) && logicMatch.items.length) {
    return logicMatch.items.map((i) => `${i.name}(${i.conceptScore})`).join('、')
  }
  return ''
}

export function hasGapUpLogicMatch(logicMatch) {
  return !!(
    logicMatch &&
    (logicMatch.type === 'switch' || (logicMatch.items && logicMatch.items.length))
  )
}
